var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.category'] = (function () {
    'use strict';

    const CONFIG = {
        COMPARE_SELECTOR: ".widget-category__compare",
        COMPARE_CONTROLS_SELECTOR: ".widget-category__compare__controls",
        COMPARE_TABLE_SELECTOR: ".widget-category__compare__table",
        COMPARE_CHECKBOX_SELECTOR: ".form-check-input",
        BREAKPOINTS: ["enter-xs", "enter-sm", "enter-md", "enter-lg", "enter-xl", "enter-xxl"]
    };

    const initialize = (widget) => {

        const compareEl = widget.querySelector(CONFIG.COMPARE_SELECTOR);
        const compareControlsEl = widget.querySelector(CONFIG.COMPARE_CONTROLS_SELECTOR);
        if (!compareEl || !compareControlsEl) return;

        // Checkbox ids in the order they were selected, so a smaller breakpoint drops the newest picks first.
        const selectionOrder = [];

        // Start with nothing selected, including after the browser restores form state.
        const checkboxes = compareControlsEl.querySelectorAll(CONFIG.COMPARE_CHECKBOX_SELECTOR);
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
            checkbox.addEventListener("change", () => {
                const index = selectionOrder.indexOf(checkbox.id);
                if (checkbox.checked && index === -1) {
                    selectionOrder.push(checkbox.id);
                }
                else if (!checkbox.checked && index !== -1) {
                    selectionOrder.splice(index, 1);
                }
                updateCompareUI(compareEl, compareControlsEl);
            });
        });

        // Bind breakpoint change events to keep the selection within the new limit.
        CONFIG.BREAKPOINTS.forEach(bp => {
            document.addEventListener(bp, () => {
                trimSelection(selectionOrder);
                updateCompareUI(compareEl, compareControlsEl);
            });
        });

        updateCompareUI(compareEl, compareControlsEl);
    };

    // Uncheck the most recent selections beyond the current breakpoint's limit.
    const trimSelection = selectionOrder => {

        const max = getCompareSelectionLimit();
        while (selectionOrder.length > max) {
            const checkbox = document.getElementById(selectionOrder.pop());
            if (checkbox) {
                checkbox.checked = false;
            }
        }
    };

    /* ==========================================================================
    UI Synchronization
    ========================================================================== */
    const updateCompareUI = (compareEl, compareControlsEl) => {

        // Synchronize UI: enforce the max limit and show/hide controlled columns.
        const checkboxes = compareControlsEl.querySelectorAll(CONFIG.COMPARE_CHECKBOX_SELECTOR);
        const limit = Math.min(getCompareSelectionLimit(), checkboxes.length);

        const checkedInfo = countCheckedCheckboxes(checkboxes);
        const checkedCount = checkedInfo.checkedCount;
        const activeCheckboxIds = checkedInfo.activeCheckboxIds;

        // Enforce max limit
        for (const checkbox of checkboxes) {
            checkbox.disabled = !checkbox.checked && checkedCount >= limit;
        }

        // Update controlled columns
        const controlledColumns = compareEl.querySelectorAll("[data-controlledby]");
        for (const column of controlledColumns) {
            const controllingId = column.getAttribute("data-controlledby");
            column.style.display = activeCheckboxIds.indexOf(controllingId) !== -1 ? "" : "none";
        }

        // Hide the table until a product is chosen, and size its columns to the selection
        const tableEl = compareEl.querySelector(CONFIG.COMPARE_TABLE_SELECTOR);
        if (tableEl) {
            tableEl.hidden = checkedCount === 0;
            tableEl.style.setProperty("--compare-count", checkedCount);
        }

        const emptyEl = compareEl.querySelector("[data-compare-empty]");
        if (emptyEl) {
            emptyEl.hidden = checkedCount !== 0;
        }

        updateCompareStatus(compareControlsEl, checkedCount, limit, checkboxes.length);
    };

    // Update the selection counter, the max-reached guidance and the limit hint (WCAG 3.3.2).
    const updateCompareStatus = (compareControlsEl, checkedCount, limit, total) => {

        const hint = compareControlsEl.querySelector("[data-compare-hint]");
        if (hint) {
            hint.textContent = `Choose up to ${limit} ${limit === 1 ? "product" : "products"} to show in the comparison table.`;
        }

        const count = compareControlsEl.querySelector("[data-compare-count]");
        if (count) {
            count.textContent = `${checkedCount} of ${limit} selected`;
        }

        const limitEl = compareControlsEl.querySelector("[data-compare-limit]");
        const limitText = compareControlsEl.querySelector("[data-compare-limit-text]");
        if (limitEl && limitText) {
            const atLimit = checkedCount >= limit && limit < total;
            limitEl.hidden = !atLimit;
            limitText.textContent = atLimit ? `Maximum of ${limit} reached. Deselect a product to choose another.` : "";
        }
    };

    /* ==========================================================================
    Helpers
    ========================================================================== */

    // Count checked checkboxes and collect their IDs for UI sync.
    const countCheckedCheckboxes = checkboxes => {

        let checkedCount = 0;
        const activeCheckboxIds = [];

        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                checkedCount++;
                activeCheckboxIds.push(checkbox.id);
            }
        }
        return { checkedCount, activeCheckboxIds };
    };

    // Get the max selection limit based on current breakpoint.
    const getCompareSelectionLimit = () => {

        switch (App.ZagBreakpoints.getBreakpoint()) {
            case 'xxl':
            case 'xl': return 4;
            case 'lg':
            case 'md': return 3;
            default: return 2;
        }
    };

    return {
        initialize
    };

})();